// utils.ts
import moment from 'moment'
import 'moment/dist/locale/zh-cn'
moment.locale('zh-cn') //中文化


export const addDates = (date, days) => {
  return moment(date, 'YYYYMMDD').add(days, 'days').format('YYYYMMDD')
}